import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "components/Table/Table.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import CSVReader from "react-csv-reader";
import SomeSpinner from "components/Somespinner/Somespinner.js"
import MaskReal from 'services/formateRS';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ModalShowStatusReportMetaImport from 'components/ModalShowStatusReportMetaImport/ModalShowStatusReportMetaImport';
import { makeStyles } from "@material-ui/core/styles";
import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";


const useStyles2 = makeStyles(styles2);

const styles = {
  margintp: {
    textAlign: "right",
    marginTop: "10px"
  },
  garlic: {
    backgroundColor: "#fff7de"
  },
  smi: {
    backgroundColor: "white"
  }
};

const useStyles = makeStyles(styles);

function ModalAddSell(props) {

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
  };

  const classes2 = useStyles2();
  const classes = useStyles();
  const [br, setBR] = React.useState(false);

  const [loading, setLoading] = useState(false);
  const [data1, setData1] = useState([]);
  const [products, setProducts] = useState([]);
  const [clients, setClients] = useState([]);
  const [productId, setProductId] = useState();
  const [clientId, setClientId] = useState();
  const [price, setPrice] = useState(null);
  const [amount, setAmount] = useState();
  const [discount, setDiscount] = useState();
  const [nf, setNf] = useState();
  const [list, setList] = useState([]);
  const [practicePrice, setPraticePrice] = useState();
  const [startDate, setStartDate] = useState(new Date().withoutTime());
  const [totalList, setTotalList] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [resultOperation, setResultOperation] = useState(0);
  const [listProducts, setListProducts] = useState([]);
  const [controlSnack, setControlSnack] = useState(false);
  const [batch, setBatch] = useState();
  const [idOne, setIdOne] = useState(0);
  const [stored, setStored] = useState(0);
  const [modalView, setModalView] = useState(false);
  const [modalViewData, setModalViewData] = useState({ success: '', errors: [] });

  const { storageId, garlicType } = useAuth();
  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };


  useEffect(() => {
    loadProducts();
    loadClients();
  }, []);

  useEffect(() => {
    loadProducts();
  }, [garlicType]);


  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);

  useEffect(() => {
    setList(listProducts);
    calcTotal();
  }, [listProducts, totalList])

  async function addToList(e) {
    e.preventDefault();
    let sell;
    if (amount === undefined || amount <= 0) {
      return alert('Quantidade inválida');
    }
    if (nf === undefined) {
      return alert('Nota fiscal inválida')
    }
    if (clientId === undefined) {
      return alert('Selecione um cliente')
    }
    if (!props.help) {
      if (batch === undefined) {
        return alert('Loteinválido')
      }
    }
    if (practicePrice === undefined || practicePrice <= 0) {
      return alert('Preço praticado inválido');
    }
    const verify_prod = list.filter(p => p.id_product == productId);
    if (verify_prod.length > 0) {
      return alert('Produtos já adicionado');
    };
    const id_product = productId ? parseInt(productId) : products[0].id

    let theProduct;
    const id_client = clientId ? clientId : clients[0].id;
    for (let i = 0; i < products.length; i++) {
      if (products[i].id === id_product) {
        theProduct = products[i];
        break;
      }
    }
    const index = products.indexOf(theProduct);
    const name = products[index].name;
    const new_code = products[index].new_code;
    let price2;
    let discount2;

    if (price) {
      price2 = price;
    } else {
      price2 = products[index].standart_price;
    }
    if (discount) {
      discount2 = discount;
    } else {
      discount2 = 0;
    }
    sell = { nf, amount, startDate, id_client, id_product, practicePrice, price2, name, idOne, discount2, batch, desconto: discount2, lote: batch, pedido: nf, data: startDate, price: practicePrice, id: new_code, quantidade: amount }

    setListProducts(prevSell => ([...prevSell, sell]));

  }

  async function calcTotal() {
    let total = 0;
    let result = 0;
    let price = 0;
    let discount = 0;
    if (listProducts) {
      for (let i = 0; i < listProducts.length; i++) {
        total = parseFloat(total) + ((parseFloat(listProducts[i].amount)) * (parseFloat(listProducts[i].practicePrice)));
        price = parseFloat(price) + ((parseFloat(listProducts[i].amount)) * (parseFloat(listProducts[i].price2)));
        discount = parseFloat(discount) + parseFloat(listProducts[i].discount2);
      }
    }
    result = total - price - discount;
    setTotalDiscount(discount);
    setResultOperation(result);
    setTotalList(total);
  }

  async function deleteToList(index) {
    let listNew = [...listProducts];
    listNew.splice(index, 1);
    setListProducts(listNew);
  }

  async function loadProducts() {
    if (garlicType === true) {
      const response = await api.get('/product/admin/garlic/' + storageId);
      setProducts(response.data);
      if (response.data.length > 0) {
        setProductId(response.data[0].id);
      };
    } else {
      const response = await api.get('/product/admin/' + storageId);
      setProducts(response.data);
      if (response.data.length > 0) {
        setProductId(response.data[0].id);
      };
    };
  };

  async function loadClients() {
    const response = await api.get('/client/sell/' + storageId);
    setClients(response.data);
  }

  async function handleAddSell(e) {
    try {
      e.preventDefault();
      setLoading(true);

      let response;
      if (data1.length === 0) {
        if (list.length === 0) {
          setLoading(false)
          return alert("nenhum produto a ser enviado");
        }
        if (props.help) {
          response = await api.post('/super/sell', {
            list,
            id_admin: storageId
          });
          if (response.status === 200) {
            setLoading(false);
            setControlSnack(true);
            //props.loadTotal();
            //props.loadSell();
            setControlSnack(false);
          } else {
            setLoading(false);
            alert(`Erro: ${response.data.message}`)
          }
        } else {
          response = await api.post('/sell', {
            data: list,
            id_admin: storageId
          });
          setStored(response.data.nfs);
          if (response.data.errors.length > 0) {
            alert(response.data.errors.join('\n'));
          }

          setLoading(false);
          setControlSnack(true);
          //props.loadTotal();
          //props.loadSell();
          setControlSnack(false);

        }
      } else {
        response = await api.post('/sell', {
          data: data1,
          id_admin: storageId
        });
        setStored(response.data.nfs);
        if (response.data.errors.length > 0) {
          alert(response.data.errors.join('\n'));
        }

        setLoading(false);
        setControlSnack(true);
        //props.loadTotal();
        //props.loadSell();
        setControlSnack(false);

      }
    } catch (error) {
      //alert(error);
    }
  }

  async function cleanList() {
    let listNew = [];
    setListProducts(listNew);
  }

  const handleForceMeta = async (data, fileInfo) => {
    setLoading(true);
    const groupedByPedido = data.reduce((acc, curr) => {
      const key = curr.n__do_pedido;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(curr);
      return acc;
    }, {});
    const sells_meta = Object.values(groupedByPedido);
    let sells_obj = [];
    sells_meta.forEach(sells => {
      let prod_per_row = [];
      sells.forEach(sell => {
        let price_vir = sell.pre_o_unit_rio.toString();
        const verify_price = price_vir.includes(',');
        if (verify_price) {
          price_vir = sell.pre_o_unit_rio.replace(',', '.')
        }
        const price = parseFloat(price_vir).toFixed(2)
        prod_per_row.push({
          cod_prod: sell.c_digo_do_produto,
          amount: sell.quantidade,
          price
        });
      });
      sells_obj.push({
        cnpj: sells[0].cnpj_cliente,
        nf: sells[0].n__da_nota_fiscal,
        sellsman_name: sells[0].nome_vendedor.trim(),
        payment_method: sells[0].prazo_de_pagto,
        date: sells[0].data_emiss_o,
        date_order: sells[0].data_do_pedido_,
        discount: sells[0].desconto,
        meta_controller: sells[0].n__do_pedido,
        type: sells[0].microconta.includes('VENDA') ? 'sell' : 'bonification',
        products: prod_per_row
      });
    });
    const response = await api.post('/sell/meta/import/' + storageId, {
      data: sells_obj
    })
    if (response.status === 200) {
      setLoading(false);
      console.log(response.data.errors)
      setModalViewData({ success: response.data.success, errors: response.data.errors });
      setModalView(true);
      //alert(`Total de sucesso: ${response.data.success}\n Erros: ${response.data.errors}`)
    } else {
      setLoading(false);
    }
  }

  function transformCnpj(cnpj) {
    const cnpjString = cnpj.toString();
    let the;
    if (cnpjString.length < 14) {
      if (cnpjString.length < 13) {
        if (cnpjString.length < 12) {
          the = "00" + "." + "0" + cnpjString[0] + cnpjString[1] + "." + cnpjString[2] + cnpjString[3] + cnpjString[4] + "/" + cnpjString[5] + cnpjString[6] + cnpjString[7] + cnpjString[8] + "-" + cnpjString[9] + cnpjString[10];
          return the;
        } else {
          the = "00" + "." + cnpjString[0] + cnpjString[1] + cnpjString[2] + "." + cnpjString[3] + cnpjString[4] + cnpjString[5] + "/" + cnpjString[6] + cnpjString[7] + cnpjString[8] + cnpjString[9] + "-" + cnpjString[10] + cnpjString[11];
          return the;
        }
      } else {
        the = "0" + cnpjString[0] + "." + cnpjString[1] + cnpjString[2] + cnpjString[3] + "." + cnpjString[4] + cnpjString[5] + cnpjString[6] + "/" + cnpjString[7] + cnpjString[8] + cnpjString[9] + cnpjString[10] + "-" + cnpjString[11] + cnpjString[12];
        return the;
      }
    } else {
      the = cnpjString[0] + cnpjString[1] + "." + cnpjString[2] + cnpjString[3] + cnpjString[4] + "." + cnpjString[5] + cnpjString[6] + cnpjString[7] + "/" + cnpjString[8] + cnpjString[9] + cnpjString[10] + cnpjString[11] + "-" + cnpjString[12] + cnpjString[13];
      return the;
    }
  }

  const handleForce = (data, fileInfo) => {
    let day;
    let transform;
    let newtest = [];
    let bol = false;
    if (data[0].v_un) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].pedido === null) {
          newtest = data.slice(0, i);
          bol = true;
          break;
        }
        for (let j = 0; j < products.length; j++) {
          if (parseInt(data[i].id) === parseInt(products[j].new_code)) {
            data[i].id_product = parseInt(products[j].id);
            break;
          }
        }
        for (let k = 0; k < clients.length; k++) {
          if (transformCnpj(data[i].cnpj) === clients[k].cnpj) {
            data[i].id_client = clients[k].id
            break;
          }
          day = data[i].data.split('/');
          transform = data[i].v_un.toString();
          data[i].price = transform.replace(/,/g, ".");
          data[i].startDate = (day[0] + "-" + day[1] + "-" + day[2]);
        }
        !bol ? setData1(data) : setData1(newtest);
      }
    } else {
      setData1(transformArray(data));
    }

  }

  function transformArray(inputArray) {
    const transformedArray = inputArray.map(item => {
      const [data, pedido, cnpj, id, quantidade, price, price2, desconto, raz_o_social, lote] = item.data.split(',');
      let fullPrice = price + "," + price2;
      return {
        cnpj: parseInt(cnpj),
        data: data.trim(),
        desconto: parseInt(desconto),
        id: parseInt(id),
        lote: lote ? lote.trim() : null,
        pedido: parseInt(pedido),
        price: parseFloat(fullPrice.replace(/"/g, '').replace(',', '.')),
        quantidade: parseFloat(quantidade),
        raz_o_social: raz_o_social.replace(/"/g, '').trim(),
      };
    });
    return transformedArray;
  }

  const tableData = () => {
    let teste = [];
    for (let i = 0; i < list.length; i++) {
      teste[i] = [];
      teste[i].push(list[i].nf);
      teste[i].push(list[i].amount);
      teste[i].push(list[i].name);
      teste[i].push(list[i].practicePrice);
      teste[i].push(
        <div className={classes2.tableActions}>
          <Tooltip
            id="tooltip-top-start"
            title="Deletar"
            placement="top"
            classes={{ tooltip: classes2.tooltip }}
          >
            <IconButton
              aria-label="Close"
              className={classes2.tableActionButton}
              onClick={() => deleteToList()}
            >
              <Close
                className={
                  classes2.tableActionButtonIcon + " " + classes2.close
                }
              />
            </IconButton>
          </Tooltip>
        </div>
      );
    };
    return teste;
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton style={garlicType === true ? styles.garlic : styles.smi}>
        <Modal.Title id="contained-modal-title-vcenter">
          Adicionar Venda
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={addToList}>
        <Modal.Body>
          <Form.Row>
            <Form.Group controlId="formGridNF">
              <Form.Label>Nota fiscal</Form.Label>
              <Form.Control onChange={event => setNf(event.target.value)} type="number" placeholder="Nota fiscal da venda" />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridProduct">
              <Form.Label>Produtos</Form.Label>
              <Form.Control onChange={event => setProductId(event.target.value)} as="select" defaultValue="Choose...">
                {products.map(product => (
                  <option key={product.id} value={product.id}>{product.name}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formGridAmount">
              <Form.Label>Quantidade</Form.Label>
              <Form.Control onChange={event => setAmount(event.target.value)} type="double" placeholder="Quantidade de produtos" />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPrice">
              <Form.Label>Preço do produto</Form.Label>
              <MaskReal value={price} onChange={value => setPrice(value.replace(',', '.'))} />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPracticePrice">
              <Form.Label>Preço praticado</Form.Label>
              <MaskReal value={practicePrice} onChange={value => setPraticePrice(value.replace(',', '.'))} />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDiscount">
              <Form.Label>Desconto</Form.Label>
              <MaskReal value={discount} onChange={value => setDiscount(value.replace(',', '.'))} />
            </Form.Group>
            {!props.help &&
              <Form.Group as={Col} controlId="formGridBatch">
                <Form.Label>Lote</Form.Label>
                <Form.Control onChange={event => setBatch(event.target.value)} type="double" placeholder="Informar lote" />
              </Form.Group>
            }
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridClients">
              <Form.Label>Clients</Form.Label>
              <Form.Control onChange={event => setClientId(event.target.value)} as="select" defaultValue="Choose...">
                {clients.map(client => (
                  <option key={client.id} value={client.id}>{client.social_reason}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridDate">
              <Form.Label>Data</Form.Label>
              <div>
                <DatePicker
                  selected={startDate}
                  onChange={date => setStartDate(date.withoutTime())}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Digite ou clique aqui"
                  disabledKeyboardNavigation />
              </div>
            </Form.Group>
          </Form.Row>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Adicionar a lista
            </Button>
            <Button color="success" onClick={cleanList}>
              Limpar a lista
            </Button>
          </div>
          {list === null ?
            (<Form.Row>
              Não há estoques na lista
            </Form.Row>)
            : (
              <Form.Row>
                <Table key={String("Table_")}
                  tableHeaderColor="danger"
                  tableHead={["NF", "Quantidade", "Produto", "Preço", "Ações"]}
                  tableData={tableData()}
                />
                <div className={classes.margintp}>
                  <b> Total de descontos: R$ {totalDiscount} </b> <b>Preço total: R${totalList}</b> <b> Resultado da operação: R$ {resultOperation}</b>
                </div>
              </Form.Row>
            )
          }

        </Modal.Body>
        <Modal.Footer>
          <div className="container">
            <div>
              <CSVReader
                cssClass="react-csv-input"
                onFileLoaded={handleForce}
                parserOptions={papaparseOptions}
              />
              <p>Escolher o CSV para importar</p>
              <div>
                <CSVReader
                  cssClass="react-csv-input"
                  onFileLoaded={handleForceMeta}
                  parserOptions={papaparseOptions}
                />
                <p>Escolher o CSV do meta para importar</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <Button color="success" onClick={handleAddSell}>
              Concluir
            </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message={stored + " vendas adicionadas com sucesso"}
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
          <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
            open={loading}
            onClick={() => { }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          {modalView && (<ModalShowStatusReportMetaImport key={`reportMeta`} data={modalViewData} show={modalView} onHide={() => setModalView(false)} />)}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ModalAddSell;